import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Private from "@/components/Private";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Kiosk from "@/pages/Kiosk";
import SuperAdmin from "@/pages/admin/SuperAdmin";
import Billing from "@/pages/admin/Billing";
import Leads from "@/pages/admin/Leads";
import LopdAdmin from "@/pages/admin/LopdAdmin";
import Dashboard from "@/pages/employer/Dashboard";
import Employees from "@/pages/employer/Employees";
import Approvals from "@/pages/employer/Approvals";
import Schedules from "@/pages/employer/Schedules";
import CalendarPage from "@/pages/employer/Calendar";
import Expenses from "@/pages/employer/Expenses";
import Documents from "@/pages/documents/Documents";
import Branding from "@/pages/employer/Branding";
import LopdCompany from "@/pages/employer/LopdCompany";
import Portal from "@/pages/employee/Portal";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/kiosk/:slug" element={<Kiosk />} />

          <Route path="/admin" element={<Private roles={["super_admin"]}><SuperAdmin /></Private>} />
          <Route path="/admin/billing" element={<Private roles={["super_admin"]}><Billing /></Private>} />
          <Route path="/admin/leads" element={<Private roles={["super_admin"]}><Leads /></Private>} />
          <Route path="/admin/lopd" element={<Private roles={["super_admin"]}><LopdAdmin /></Private>} />

          <Route path="/dashboard" element={<Private roles={["company_admin"]}><Dashboard /></Private>} />
          <Route path="/employees" element={<Private roles={["company_admin"]}><Employees /></Private>} />
          <Route path="/schedules" element={<Private roles={["company_admin"]}><Schedules /></Private>} />
          <Route path="/calendar" element={<Private roles={["company_admin"]}><CalendarPage /></Private>} />
          <Route path="/approvals" element={<Private roles={["company_admin"]}><Approvals /></Private>} />
          <Route path="/expenses" element={<Private roles={["company_admin"]}><Expenses /></Private>} />
          <Route path="/documents" element={<Private roles={["company_admin", "gestoria"]}><Documents /></Private>} />
          <Route path="/branding" element={<Private roles={["company_admin"]}><Branding /></Private>} />
          <Route path="/lopd" element={<Private roles={["company_admin"]}><LopdCompany /></Private>} />

          <Route path="/portal" element={<Private roles={["employee"]}><Portal /></Private>} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
